import { Suspense, lazy } from "react";

import Guest from "src/components/Guest";
import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Login = Loader(lazy(() => import("src/content/auth/Login")));

const accountRoutes = [
  {
    path: "login",
    element: (
      <Guest>
        <Login />
      </Guest>
    ),
  },
];

export default accountRoutes;
